import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgKojicAcidGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m20.996 25.885-1.37.64-.65 3.829-1.349-2.89-1.13.52 2.67 5.709 1.12-.52-.55-1.19.32-1.45 2.618 1.52 1.35-.63-3.619-2.14.59-3.398ZM23.805 24.575l.46 6.738 1.21-.57-.12-1.489 2.279-1.06 1.06 1.04 1.22-.57-4.88-4.668-1.229.58Zm1.5 1.34 1.51 1.47-1.57.73-.16-2.1-.04-.37.26.27Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M33.072 11.24 17.077 10 8 23.236l6.928 14.475 16.005 1.24 9.077-13.236-6.938-14.475ZM30.303 37.65l-14.555-1.13L9.44 23.347 17.697 11.3l14.565 1.13 6.308 13.175-8.267 12.046Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M19.926 21.916c1.82 0 3.3-1.48 3.3-3.299 0-1.82-1.48-3.299-3.3-3.299a3.302 3.302 0 0 0-3.299 3.3c0 1.819 1.49 3.298 3.3 3.298Zm0-5.348c1.13 0 2.05.92 2.05 2.05 0 1.129-.92 2.049-2.05 2.049s-2.05-.92-2.05-2.05.92-2.049 2.05-2.049ZM33.802 20.567c-.29-.41-.72-.69-1.22-.78-.5-.09-1 .02-1.41.31-.41.29-.689.72-.779 1.22-.09.5.02 1 .31 1.409a1.897 1.897 0 0 0 1.55.81c.38 0 .76-.12 1.08-.34.409-.29.689-.72.779-1.22.09-.5-.02-1-.31-1.41Zm-1.19 1.6a.63.63 0 0 1-.48.11.627.627 0 0 1-.41-.26.63.63 0 0 1 .15-.89.621.621 0 0 1 .88.15c.1.14.14.31.11.48-.01.17-.11.31-.25.41ZM27.454 20.067a2.327 2.327 0 0 0 2.29-1.93c.11-.62-.03-1.24-.38-1.749-.36-.51-.89-.85-1.51-.96-.62-.11-1.24.03-1.75.38-1.06.74-1.32 2.2-.58 3.26.47.649 1.19.999 1.93.999Zm-.62-3.23c.18-.13.4-.2.62-.2.06 0 .13.01.19.02.29.05.54.21.7.45.17.24.23.53.18.81-.05.28-.21.54-.45.7-.49.34-1.17.22-1.52-.27a1.09 1.09 0 0 1 .28-1.51Z",
    fill: "currentColor"
  }));
}

export { SvgKojicAcidGlyph as default };
